// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--3hjyk","reference":"styles-module--reference--2-3iy","title":"styles-module--title--12JF9"};